import Vue from "vue";
import Router from "vue-router";
import CompanyHome from "@/views/CompanyHome.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash, offset: { x: 0, y: 80 } };
    }
    return { x: 0, y: 0 };
  },
  routes: [
    { path: "/", name: "Home", component: CompanyHome },
    {
      path: "/extraction",
      name: "Extraction",
      component: () => import("@/views/ExtractionProcess.vue"),
    },
    {
      path: "/where-to-buy",
      name: "WhereToBuy",
      component: () => import("@/views/WhereToBuy.vue"),
    },
    {
      path: "/customer-service",
      name: "CustomerService",
      component: () => import("@/views/CustomerService.vue"),
    },
    {
      path: "/:asin",
      name: "CompanyHomeAsin",
      component: () => import("../views/CompanyHomeAsin.vue"),
    },
  ],
});
